import script from "./FormattedInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormattedInput.vue?vue&type=script&setup=true&lang=ts"

import "./FormattedInput.vue?vue&type=style&index=0&id=985e1c90&lang=scss&scoped=true"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-985e1c90"]])

export default __exports__